import { MoneyWithDecimals } from '../moneyWithDecimals';
import styles from './RepaymentSummaryItem.module.css';

const RepayMoney = (props) => {
    return (
        <MoneyWithDecimals
            integerWithSymbolClassName={styles.RepayMoneyInteger}
            decimalWithSeparatorClassName={styles.RepayMoneyDecimals}
            className={styles.RepayMoney}
            {...props}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default RepayMoney;
